// @flow
import { useMemo } from 'react';
import moment from 'moment-timezone';
import petrovich from 'petrovich';
import prop from 'ramda/es/prop';
import toLower from 'ramda/es/toLower';
import { useTranslation } from 'react-i18next';

import config from 'app/config';

import * as dateTypes from 'app/common/constants/dateTypes';


/**
 * Создение заголовка на основе даты, типа даты, имени и шаблона
 * ex.: "График питания Артема за октябрь 2019"
 */

type Props = {
  date: string,
  dateType: $Values<typeof dateTypes>,
  name: {
    first: string,
    last: string,
    middle: string,
    gender: 'male' | 'female' | 'androgynous',
  },
  ns: string,
  i18nId: string,
}

const useHeaderByDateI18n = ({ date, dateType, name, ns, i18nId }: Props) => {
  const { t } = useTranslation(ns);

  const res = useMemo(() => {
    const mDate = moment(date, config.dateFormat);
    const datePresentative = (dateType === dateTypes.MONTHS
      ? toLower(mDate.format('MMMM YYYY'))
      : mDate.format(config.dateFormatPresentative));
    const who = prop('first', petrovich(name, 'genitive'));

    return t(i18nId, { name: who, date: datePresentative });
  }, [name, date, dateType, i18nId, t]);

  return res;
};

export default useHeaderByDateI18n;
